import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PointReplacerPipe } from './point-replacer.pipe';
import { CurrencyRealReplacerPipe } from './currency-real-replacer.pipe';
import { RemoveConsorcioPipe } from './remove-consorcio.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        PointReplacerPipe,
        CurrencyRealReplacerPipe,
        RemoveConsorcioPipe
    ],
    exports: [
        PointReplacerPipe,
        CurrencyRealReplacerPipe,
        RemoveConsorcioPipe
    ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./src/app/pipes/pipes.module.ts